import React from 'react'
import { CKEditor } from '@ckeditor/ckeditor5-react'
import {
	ClassicEditor,
	Essentials,
	Paragraph,
	Bold,
	Italic,
	Underline,
	Strikethrough,
	Font,
	Link,
	Image,
	ImageUpload,
	List,
	Heading,
	BlockQuote,
	Table,
	TableToolbar,
	Indent,
	Alignment,
	MediaEmbed,
	Autoformat
} from 'ckeditor5'
import 'ckeditor5/ckeditor5.css'

import { uploadFile, getFile } from '../../lib/ckeditor5'

class UploadAdapter {
	constructor(loader) {
		this.loader = loader
	}

	async upload() {
		try {
			const file = await this.loader.file

			console.log('file', file)

			if (file.size > 5e6) {
				throw new Error('Please upload a file smaller than 5 MB')
			}

			// Generate a unique filename
			const filename = `${Date.now()}-${file.name}`

			// Step 1: Upload the file to Supabase using your helper function
			const uploadResponse = await uploadFile(filename, file)
			console.log('File uploaded:', uploadResponse)

			// Step 2: Get the public URL of the file
			const publicUrlResponse = await getFile(filename)
			console.log('Public file URL:', publicUrlResponse)

			// Ensure public URL is available
			if (publicUrlResponse.publicUrl) {
				// Step 3: Resolve with the URL so CKEditor can embed it
				return {
					default: publicUrlResponse.publicUrl // Embed the public URL in CKEditor
				}
			} else {
				throw new Error('Failed to get public URL')
			}
		} catch (error) {
			console.error('Upload error:', error)
			throw error
		}
	}

	abort() {
		// Handle abort case if needed
	}
}

// Custom plugin to add the upload adapter to CKEditor
function UploadAdapterPlugin(editor) {
	editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
		return new UploadAdapter(loader)
	}
}

// fixedViewportHeight: number (px) or CSS length string (e.g. '50vh') — locks editable height, scroll inside.
const TextEditor = ({ value, setValue, fixedViewportHeight }) => {
	const heightCss =
		fixedViewportHeight == null
			? undefined
			: typeof fixedViewportHeight === 'number'
				? `${fixedViewportHeight}px`
				: fixedViewportHeight

	return (
		<div
			className={`text-editor-resizable-wrap${heightCss != null ? ' text-editor-fixed-viewport' : ''}`}
			style={heightCss != null ? { '--te-editable-height': heightCss } : undefined}
		>
			<CKEditor
				editor={ClassicEditor}
				data={value || ''}
				config={{
					licenseKey: 'GPL',
					plugins: [
						Essentials,
						Paragraph,
						Bold,
						Italic,
						Underline,
						Strikethrough,
						Font,
						Link,
						Image,
						ImageUpload,
						List,
						Heading,
						BlockQuote,
						Table,
						TableToolbar,
						Indent,
						Alignment,
						MediaEmbed,
						Autoformat
					],
					toolbar: [
						'undo', 'redo',
						'|',
						'heading',
						'|',
						'bold', 'italic', 'underline', 'strikethrough',
						'|',
						'fontColor', 'fontBackgroundColor',
						'|',
						'fontSize', 'fontFamily',
						'|',
						'alignment',
						'|',
						'bulletedList', 'numberedList',
						'|',
						'outdent', 'indent',
						'|',
						'link', 'uploadImage', 'insertTable', 'blockQuote', 'mediaEmbed'
					],
					table: {
						contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells']
					},
					extraPlugins: [UploadAdapterPlugin]
				}}
				onChange={(event, editor) => {
					setValue(editor.getData())
				}}
			/>
		</div>
	)
}

export { TextEditor }
